export default __webpack_public_path__ + "media/images/users/user-cristal-smith-270x270-eef79cc517f7aa9453c00d4bab69ad64.jpg";